module.exports = __webpack_public_path__ + "img/linkedin.459c66b2.svg";